export default __webpack_public_path__ + "static/media/RadicalRocks_00.ec7b1bd3.png";